import { Routes, Route } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";

import NotFound from "./pages/NotFound";
import TokenRedirect from "./pages/TokenRedirect";
import Logout from "./pages/Logout";
import DashBoard from "./pages/DashBoard";

import HeaderNavBar from "./layout/HeaderNavBar";
import Footer from "./layout/Footer";
import MenuSide from "./layout/MenuSide";

import withGuard from "./utils/withGuard";
import { useTenant, useStartup } from "./hooks";
import { MwSpinner } from "./components/ui";

import Settings from "./pages/Settings";
import TicketCreate from "./pages/TicketCreate";
import TicketsManage from "./pages/TicketsManage";
import TicketsShow from "./pages/TicketsShow";
import ProjectsManage from "./pages/ProjectsManage";
import ProjectForm from "./pages/ProjectForm";
import ProjectShow from "./pages/ProjectShow";
import Reports from "./pages/Reports"; // <--- 1. إضافة استيراد صفحة التقارير الجديدة
import PendingActionGuard from "./components/tickets/PendingActionGuard";

function App() {
  const [openMenu, setOpenMenu] = useState(false);
  const langState = useSelector((state) => state.lang);
  const { tenant, tenantUsername, loading: loadingTenant, companiesList, branchesList, tenantId, companySelected, branchSelected } = useTenant();
  const { startup } = useStartup();
  
  return (
    !loadingTenant && startup ? (
      <div dir={langState?.value === 'ar' ? 'rtl' : 'ltr'} className="h-screen flex flex-col flex-between overflow-hidden">
        <Toaster
          position={langState?.value === 'ar' ? 'top-left' : 'top-right'}
          toastOptions={{
            duration: 3000,
            style: {
              fontFamily: "'Cairo', 'Segoe UI', sans-serif",
              fontWeight: 700,
              fontSize: 13,
            },
            success: {
              iconTheme: {
                primary: '#16a34a',
                secondary: '#ffffff',
              },
            },
            error: {
              iconTheme: {
                primary: '#dc2626',
                secondary: '#ffffff',
              },
            },
          }}
        />
        <HeaderNavBar
          companySelected={companySelected}
          branchSelected={branchSelected}
          companiesList={companiesList}
          branchesList={branchesList}
          tenantUsername={tenantUsername}
          tenant={tenant}
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
        />
        <div className="bg-white flex flex-1 m-auto w-full overflow-hidden">
          <MenuSide
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
          />
          <div className={`flex flex-col flex-1 min-w-0 px-2 py-1 pe-3 primary-bg-color ${openMenu ? 'ms-8 md:ms-0 ps-3' : 'md:ms-10'}`}>
            <div
              className="p-5 pb-10 rounded-2xl bg-slate-50 overflow-auto shadow-sm"
              style={{
                minHeight: 'calc(100vh - var(--header-height, 72px) - var(--footer-height, 28px))',
                maxHeight: 'calc(100vh - var(--header-height, 72px) - var(--footer-height, 28px))'
              }}
            >
              {/* قفل الصفحات لحد ما الأدمن يعلّق على تذكرة "إجبار التعليق". */}
              <PendingActionGuard lang={langState?.value} />
              <Routes>
                <Route path="/" element={<DashBoard />} />
                <Route path=":tenant/" element={<DashBoard />} />
                <Route path=":tenant/dashboard" element={<DashBoard />} />
                <Route path=":tenant/token/:token" element={<TokenRedirect />} />
                <Route path=":tenant/logout" element={<Logout />} />
                <Route path=":tenant/settings" element={<Settings />} />
                
                {/* <--- 2. إضافة مسار صفحة التقارير هنا ---> */}
                <Route path=":tenant/reports" element={<Reports />} />
                
                <Route path=":tenant/tickets/add" element={<TicketCreate />} />
                <Route path=":tenant/tickets" element={<TicketsManage />} />
                <Route path=":tenant/tickets/show/:id" element={<TicketsShow />} />
                <Route path=":tenant/projects" element={<ProjectsManage />} />
                <Route path=":tenant/projects/add" element={<ProjectForm />} />
                <Route path=":tenant/projects/edit/:id" element={<ProjectForm key="edit" />} />
                <Route path=":tenant/projects/show/:id" element={<ProjectShow />} />
                <Route path=":tenant/project/show/:id" element={<ProjectShow />} />
                <Route path="/notfound" element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    ) : (
      <MwSpinner />
    )
  );
}

export default withGuard(App);
